import { Subfolder } from "../../redux/interfaces/folder.types";

const formValue = (
  subfolder: Subfolder,
  formSlug: string,
  key: string,
): string => {
  const req = (subfolder.requirements ?? []).find((r) => r.slug === formSlug);
  return req?.form_values?.find((fv) => fv.key === key)?.value?.trim() || "";
};

/**
 * Owner's display name pulled from its filled forms:
 *  - PF (landlord-form): first + last names.
 *  - PM (business-short-form): the company's legal name (razón social).
 * Returns undefined when nothing is filled yet (caller decides the fallback).
 */
export function getOwnerNameFromForms(subfolder: Subfolder): string | undefined {
  const pfName = [
    formValue(subfolder, "landlord-form", "first_name"),
    formValue(subfolder, "landlord-form", "first_last_name"),
    formValue(subfolder, "landlord-form", "second_last_name"),
  ]
    .filter(Boolean)
    .join(" ")
    .trim();
  if (pfName) return pfName;

  const razonSocial = formValue(
    subfolder,
    "business-short-form",
    "business_legal_name",
  );
  if (razonSocial) return razonSocial;

  return undefined;
}
